import React, { useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridPaginationModel, GridRowSelectionModel } from '@mui/x-data-grid';
import User from '../models/iUser';
import { Grid } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import { IUserSearchApiResponse } from '../models/iUserSearchApiResponse';
import { searchUsers } from '../providers/identityApi';

interface IUserDataGridProps {
  firstName: string;
  lastName: string;
  email: string;
  setAddedUser: React.Dispatch<React.SetStateAction<User | null | undefined>>;
}

const NewUserDataGrid: React.FC<IUserDataGridProps> = ({ firstName, lastName, email, setAddedUser }) => {
  const { authState } = useOktaAuth();
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);

  const fetchData = async (pageNumber: number, pageSize: number) => {
    if (authState?.accessToken?.accessToken) {
      if (firstName.length > 0 || lastName.length > 0 || email.length > 0) {
        setAddedUser(null);
        setLoading(true);
        try {
          const searchFilter = {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
          };
          const response: IUserSearchApiResponse<User> = await searchUsers(
            authState.accessToken.accessToken,
            searchFilter,
            pageNumber + 1,
            pageSize,
            'FirstName',
            true,
            pageNumber * pageSize
          );

          const usersWithRoles = response.valueOrDefault.map((user) => ({
            ...user,
            roles: user.roles || [],
          }));

          setUsers(usersWithRoles);
          setRowCount(response.totalItems);
        } catch (error) {
          console.error('Error fetching users:', error);
        } finally {
          setLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    fetchData(page, pageSize);
  }, [page, pageSize, firstName, lastName, email]);

  const columns: GridColDef[] = [
    { field: 'firstName', headerName: 'First name', width: 150 },
    { field: 'lastName', headerName: 'Last name', width: 150 },
    { field: 'email', headerName: 'Email', width: 250 },
    // Add more columns as needed
  ];

  const handlePaginationModelChange = (model: GridPaginationModel) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  const handleRowSelection = (selectedRows: GridRowSelectionModel) => {
    const selectedUser = users.find((user) => user.id === selectedRows[0]);
    setAddedUser(selectedUser || null);
  };

  return (
    <DataGrid
      rows={users}
      columns={columns}
      pagination
      rowCount={rowCount}
      paginationMode="server"
      initialState={{
        pagination: {
          paginationModel: { pageSize: 10, page: 0 },
        },
      }}
      onPaginationModelChange={handlePaginationModelChange}
      onRowSelectionModelChange={handleRowSelection}
      loading={loading}
      pageSizeOptions={[10, 20, 50, 100]}
      autoHeight
    />
  );
};

export default NewUserDataGrid;
